import React, { useState, useMemo } from 'react';
import { CnBaseTable } from '@sto/cn-ui';
import styles from './index.module.scss';

const getTableData = (res) => {
  const columns = [];
  const headerMap = {};
  let maxWidth = 0;
  const { pagination } = res;
  if (res.header) {
    res.header?.forEach((item, index) => {
      if (!item.isColHide) {
        const headerObj: any = {
          title: item.name,
          dataIndex: item.code,
          width: item.width || 100,
          clickable: item.clickable || false,
          sortable: item.sortable,
          align: item.align || 'center',
          alignHeader: item.alignHeader || 'center',
          lock: item.lock,
          editType: item.editType || 'input',
          backgroundcolor: item.bgColor || '',
          fontColor: item.fontColor || '',
          bubbleText: item.bubbleText || '',
          iscustomrendering: item.isCustomRendering || false, // 是否定制渲染列
        };
        maxWidth += item.width || 100;
        columns.push(headerObj);
        headerMap[item.code] = headerObj;
      }
      if (item.children && item.children.length) {
        columns[index].children = [];
        item.children.forEach((item1) => {
          const headerObj = {
            ...item1,
            title: item1.name,
            dataIndex: item1.code,
            width: item1.width || 100,
            clickable: item1.clickable,
            sortable: item1.sortable,
            align: item1.align || 'center',
            alignHeader: item1.alignHeader || 'center',
            lock: item1.lock,
            editType: item1.editType || '',
          };
          columns[index].children.push(headerObj);
          headerMap[item1.code] = headerObj;
        });
      }
    });
  } else if (res.columns) {
    res.columns.forEach((item) => {
      columns.push(item);
    });
  }

  return {
    // maxWidth: Math.max(maxWidth + 10, 390),
    maxWidth: 'unset',
    columns,
    dataSource: res.rows || res.dataSource,
    pagination,
  };
};

function SimplePagination({
  current,
  total,
  pageSize,
  onChange,
}) {
  if (total <= pageSize) return null;
  const totalPages = Math.ceil(total / pageSize);
  const maxVisibleButtons = 5;
  const displayRange = [];
  if (totalPages <= maxVisibleButtons) {
    for (let i = 1; i <= totalPages; i++) displayRange.push(i);
  } else {
    const halfVisible = Math.floor((maxVisibleButtons - 2) / 2);
    displayRange.push(1);
    const startPage = Math.max(2, current - halfVisible);
    const endPage = Math.min(totalPages - 1, startPage + maxVisibleButtons - 3);
    if (startPage > 2) displayRange.push('...');
    for (let i = startPage; i <= endPage; i++) displayRange.push(i);
    if (endPage < totalPages - 1) displayRange.push('...');
    if (totalPages > 1) displayRange.push(totalPages);
  }
  return (
    <div className={styles.simplePaginationWrapper}>
      <button
        className={styles.simplePageButton}
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        aria-label="上一页"
      >
        {'<'}
      </button>
      {displayRange.map((page, idx) =>
        page === '...'
          ? <span key={`ellipsis-${idx}`} className={styles.simpleEllipsis}>·</span>
          : <button
              key={page}
              className={
                page === current
                  ? `${styles.simplePageButton} ${styles.simpleActive}`
                  : styles.simplePageButton
              }
              onClick={() => onChange(page)}
            >
              {page}
            </button>
      )}
      <button
        className={styles.simplePageButton}
        onClick={() => onChange(current + 1)}
        disabled={current === totalPages}
        aria-label="下一页"
      >
        {'>'}
      </button>
    </div>
  );
}

const CTable = ({ content, showTableTitle = false }) => {
  if (!content) return null;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const { columns, maxWidth, dataSource: allData } = getTableData(content);
  const paginatedData = useMemo(() => {
    if (!allData || !Array.isArray(allData)) return [];
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return allData.slice(startIndex, endIndex);
  }, [allData, currentPage, pageSize]);
  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil((allData?.length || 0) / pageSize)) return;
    setCurrentPage(page);
  };
  return (
    <div style={{ width: maxWidth, maxWidth: '100%', margin: '5px 0 0' }} className={showTableTitle ? styles.tableWrapper : styles.tableWrapperNoTitle}>
      {showTableTitle && <div className={styles.tableTitle}>{content?.title || '详细信息'}</div>}
      <CnBaseTable
        isStickyHeader
        style={{ overflow: 'auto', paddingBottom: 0 }}
        size="small"
        columns={columns}
        dataSource={paginatedData}
        isZebra
        zebraColor="#FAFBFC"
      />
      {allData && Array.isArray(allData) && allData.length > pageSize && (
        <SimplePagination
          current={currentPage}
          total={allData.length}
          pageSize={pageSize}
          onChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default CTable;
